<template id="categoryTemplate">
  <div class="component-container">
    <app-navigation v-bind:isDisabled="formState.loading"></app-navigation>
    <div class="component__wrapper flex-div text-left" :class="formState.invalidShake?'invalid':''">
      <div class="p-0 form-group flex-div">
        <legend class="pl-0" for="categories">All {{getPlural($route.params.categoryType)}}</legend>
        <div class="p-0 mb-4 flex-div">
          <input
            class="form-control"
            type="text"
            maxlength="200"
            :placeholder="'Search All ' + getPlural($route.params.categoryType)"
            v-model="categoriesSearch"
          />
        </div>
        <b-form-select
          :disabled="formState.loading"
          class="p-0"
          style="font-size:16px;"
          v-model="selectedCategoryId"
          :options="filteredCategories"
          :select-size="+10"
        ></b-form-select>
      </div>
      <form class="pl-0 pr-0 category-form container1" v-if="selectedCategoryData">
        <div v-if="errors.length && formState.attempted && (!formState.loading)" class="flex-div">
          <b class="w-100">Please correct the following error(s):</b>
          <ul>
            <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
          </ul>
        </div>
        <hr />
        <fieldset :disabled="formState.loading" v-if="selectedCategoryData" class="p-0">
          <legend>Category's Main Data</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-6 flex-div">
              <label class="pl-0" for="title">Title</label>
              <input
                v-on:input="checkForm"
                class="form-control"
                required
                type="text"
                maxlength="200"
                v-model="selectedCategoryData.mainData.title"
                id="title"
                placeholder="Title"
              />
            </div>

            <div class="form-group col-12 col-sm-6 flex-div">
              <label class="pl-0" for="titleEN">Title(EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control"
                required
                type="text"
                maxlength="200"
                v-model="selectedCategoryData.mainData.title_en"
                id="titleEN"
                placeholder="Title(EN)"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-sm-6 flex-div">
              <label class="pl-0" for="name">Name</label>
              <input
                v-on:input="checkForm"
                class="form-control"
                required
                type="text"
                maxlength="200"
                v-model="selectedCategoryData.mainData.name"
                id="name"
                placeholder="Name"
              />
            </div>
            <div class="form-group col-12 col-sm-6 flex-div">
              <label class="pl-0" for="nameEN">Name(EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control"
                required
                type="text"
                maxlength="200"
                v-model="selectedCategoryData.mainData.name_en"
                placeholder="Name(EN)"
                id="nameEN"
              />
            </div>
            <div class="form-group col-12 col-sm-6 flex-div">
              <label class="pl-0" for="nameEN">Parent Category</label>
              <b-form-select
                :disabled="formState.loading"
                class="modified-dropdown col-12 col-sm-12"
                :options="parentCategories.filter((a)=>{return a.value != selectedCategoryId})"
                v-if="selectedCategoryData.categoryRelations[0]"
                v-model="selectedCategoryData.categoryRelations[0].parent_id"
              ></b-form-select>
              <small v-else>This category is a root category with no parents</small>
            </div>
          </div>
        </fieldset>
        <!-- <hr /> -->
        <fieldset :disabled="formState.loading" v-if="selectedCategoryData" class="p-0">
          <!-- <legend>Category's Exisiting Meta Data</legend> -->
          <div class="row">
            <div
              style="min-height:100px;margin-bottom:10px;"
              class="flex-div"
              :class="findMeta(meta.category_meta_id)?findMeta(meta.category_meta_id).valueType=='file'?'col-12 col-sm-12':'col-12 col-sm-6':'hidden'"
              v-for="(meta,index) in selectedCategoryData.categoryMetaRelations"
              :key="index"
            >
              <div class="w-100" v-if="findMeta(meta.category_meta_id)">
                <strong v-if="$route.params.categoryType.toLowerCase() == 'akmam'">If you want this akmam category to be a parent, please do not add a photo.</strong>
                <strong v-if=" (findMeta(meta.category_meta_id).valueType=='file')">

                  <span v-if="$route.params.categoryType.toLowerCase() == 'fabric'">
                    Don't add an image if the fabric is a parent fabric (i.e. its parent is "Cloth Type").
                    <br>
                    <br>
                  </span>
                  Please use an image that has an aspect ratio of
                  <br>
                  <br>

                  <span v-if="findMeta(meta.category_meta_id).type == 'measurement-table'">
                    <span  >1 : {{parseFloat(501/665).toFixed(2)}} (W : H) for Measurement tables</span>
                    <br>
                    <br>
                  </span>

                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'fabric'">
                    <span>1 : {{parseFloat(130/320).toFixed(2)}} (W : H) for Fabrics - Example: 320x130</span>
                    <br>
                  </span>

                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'general'">
                    <span >1 : {{parseFloat(700/700).toFixed(2)}} (W : H) for General Categories</span>
                    <br>
                  </span>

                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'color'">
                    <span>1 : {{parseFloat(50/100).toFixed(2)}} (W : H) - Example: 100x50</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'yaka'">
                    <span>1 : {{parseFloat(75/75).toFixed(2)}} (W : H) for Yakas - Example: 75x75</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'zarzour'">
                    <span>1 : {{parseFloat(75/75).toFixed(2)}} (W : H) for Zarzours - Example: 75x75</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'akmam'">
                    <span>1 : {{parseFloat(75/75).toFixed(2)}} (W : H) for Akmams - Example: 75x75</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'betana'">
                    <span>1 : {{parseFloat(130/320).toFixed(2)}} (W : H) for Betanas - Example: 320x130</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'accessory'">
                    <span>1 : {{parseFloat(130/320).toFixed(2)}} (W : H) for Accessories - Example: 320x130</span>
                    <br>
                  </span>

                  Ignoring this may cause distortion of the image on the website
                </strong>
                <br v-if=" (findMeta(meta.category_meta_id).valueType=='file')">
                <label
                  style="text-transform:capitalize"
                  class="pl-0"
                  for="meta"
                >{{findMeta(meta.category_meta_id).type.replace(/(-|_)/g, ' ')}}</label>
                <small
                  v-if=" (findMeta(meta.category_meta_id).valueType=='file')"
                >Current File Reference, you can change the url or you can upload a new file.</small>
                <input
                  v-if="(findMeta(meta.category_meta_id).valueType!='options')"
                  class="form-control"
                  type="text"
                  :maxlength="$route.params.categoryType.toLowerCase() == 'fabric' && findMeta(meta.category_meta_id).valueType!='file'? 150 : 200"
                  v-model="meta.value"
                  :placeholder="findMeta(meta.category_meta_id).type.replace(/(-|_)/g, ' ')"
                />

                <small
                  v-if=" (findMeta(meta.category_meta_id).valueType=='file')"
                >To upload a new file, click choose file.</small>
                <input
                  v-if=" (findMeta(meta.category_meta_id).valueType=='file')"
                  class="col-12 col-sm-12 mt-4 pl-0"
                  type="file"
                  :id="'file'+index"
                  @change="uploadFile(meta,index, false,findMeta(meta.category_meta_id).type=='measurement-table')"
                />
                <b-form-select
                  :disabled="formState.loading"
                  class="modified-dropdown col-12 col-sm-12"
                  v-if=" (findMeta(meta.category_meta_id).valueType=='options')"
                  :options="findMeta(meta.category_meta_id).options"
                  v-model="meta.value"
                ></b-form-select>
              </div>
            </div>
          </div>
        </fieldset>

        <hr v-if="selectedCategoryData" class="separator --black" />

        <fieldset :disabled="formState.loading" v-if="newMetas.length" class="p-0">
          <legend>
            New Meta Data You Added
            <small>To ignore adding a new meta, just leave it empty</small>
          </legend>

          <div
            style="min-height:100px;margin-bottom:10px;"
            class="form-group col-12 col-sm-6 flex-div"
            v-for="(meta,index) in newMetas"
            :key="index"
          >
                        <strong v-if="(meta.valueType=='file') && $route.params.categoryType.toLowerCase() == 'akmam'">If you want this akmam category to be a parent, please do not add a photo.</strong>
            <label
              style="text-transform:capitalize"
              class="pl-0"
              for="meta"
            >{{meta.type.replace(/(-|_)/g, ' ')}}</label>
            <input
              v-if="(meta.valueType=='text')"
              class="form-control"
              type="text"
              :maxlength="$route.params.categoryType.toLowerCase() == 'fabric' ? 150 : 200"
              v-model="meta.data"
              :placeholder="meta.type.replace(/(-|_)/g, ' ')"
            />
            <input
              v-if="(meta.valueType=='file')"
              class="col-12 col-sm-12 pl-0"
              type="file"
              :id="'newMetaFile'+index"
              @change="uploadFile(meta,index,true)"
            />
            <br v-if="(meta.valueType=='file')">
            <strong v-if="(meta.valueType=='file')">

              <span v-if="$route.params.categoryType.toLowerCase() == 'fabric'">
                Don't add an image if the fabric is a parent fabric (i.e. its parent is "Cloth Type").
                <br>
                <br>
              </span>

              Please use an image that has an aspect ratio of
              <br>

                  <span v-if="findMeta(meta.category_meta_id).type == 'measurement-table'">
                    <span  >1 : {{parseFloat(501/665).toFixed(2)}} (W : H) for Measurement tables</span>
                    <br>
                  </span>

                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'fabric'">
                    <span>1 : {{parseFloat(130/320).toFixed(2)}} (W : H) for Fabrics - Example: 320x130</span>
                    <br>
                  </span>

                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'general'">
                    <span >1 : {{parseFloat(700/700).toFixed(2)}} (W : H) for General Categories</span>
                    <br>
                  </span>

                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'color'">
                    <span>1 : {{parseFloat(50/100).toFixed(2)}} (W : H) - Example: 100x50</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'yaka'">
                    <span>1 : {{parseFloat(75/75).toFixed(2)}} (W : H) for Yakas - Example: 75x75</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'zarzour'">
                    <span>1 : {{parseFloat(75/75).toFixed(2)}} (W : H) for Zarzours - Example: 75x75</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'akmam'">
                    <span>1 : {{parseFloat(75/75).toFixed(2)}} (W : H) for Akmams - Example: 75x75</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'betana'">
                    <span>1 : {{parseFloat(130/320).toFixed(2)}} (W : H) for Betanas - Example: 320x130</span>
                    <br>
                  </span>
                  
                  <span v-else-if="$route.params.categoryType.toLowerCase() == 'accessory'">
                    <span>1 : {{parseFloat(130/320).toFixed(2)}} (W : H) for Accessories - Example: 320x130</span>
                    <br>
                  </span>
              
              Ignoring this may cause distortion of the image on the website
            </strong>
            <br v-if="(meta.valueType=='file')">
            <b-form-select
              :disabled="formState.loading"
              class="modified-dropdown col-12 col-sm-12"
              v-if="(meta.valueType=='options')"
              :options="meta.options"
              v-model="meta.data"
            ></b-form-select>
          </div>
        </fieldset>

        <div class="form-group flex-div" v-if="selectedCategoryData">
          <label class="pl-0">Add New Meta Data</label>
          <div class="w-100 d-flex">
            <b-form-select
              :disabled="formState.loading"
              class="modified-dropdown col-12 col-sm-7 mb-4"
              v-model="selectedNewMetaId"
              :options="selectionMetas"
            ></b-form-select>
            <div class="col-12 col-sm-3">
              <button
                :disabled="formState.loading"
                type="button"
                v-on:click="addNewMeta()"
                class="btn btn-primary"
              >Add new meta data</button>
            </div>
          </div>
        </div>

        <hr v-if="selectedCategoryData" class="separator --black" />

        <div class="justify-content-between w-100 row" v-if="selectedCategoryData">
          <div class="col-12 col-sm-3">
            <button
              type="button"
              v-on:click="deleteCategory()"
              class="mb-4 w-100 btn btn-danger"
              :disabled="formState.loading"
            >Delete Selected Category</button>
          </div>

          <div class="col-12 col-sm-3">
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="commitChanges()"
              class="mb-4 w-100 btn btn-info"
            >Confirm Changes</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>



<!-- category Template -->




<style lang='scss' scoped>
@import "../assets/css/_global.scss";
.hidden {
  display: none !important;
}
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}
.component__wrapper {
  float: right;
  width: 80%;
  padding: 50px;

  .flex-div {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
    align-items: center;
  }

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }
}
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { copyFile } from "fs";
/* eslint-enable no-unused-vars*/
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";

import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "EditCategory",
  data() {
    return {
      categoriesSearch: "", // We search All categories Depending on this.
      selectedCategoryId: null, // Specifies The Id of the selected Category in the database
      selectedCategoryData: null, // Data is fetched from the backend using selectedCategoryId
      parentCategories: [],
      categories: [
        {
          value: null,
          text: "Please select a category to edit"
        }
      ], // All Categories (Fetched When component is mounted)
      filteredCategories: [
        {
          value: null,
          text: "Please select a category to edit"
        }
      ], // All Categories Filtered Using categoriesSearch
      metas: [], // All Meata Data Fetched from the backend when component is Mounted.
      selectionMetas: [
        {
          value: null,
          text: "Please select a meta to add"
        }
      ], // Same data within metas [], but keys are adjusted to allow the dropdown menu to work.
      selectedNewMetaId: null, // Specifies the ID of the meta to be added to the category in the database
      newMetas: [], // The new metas to be added to the category
      errors: [], // Form's errors
      sizeTypes: [
        {
          value: null,
          text: "Please select an option"
        },
        {
          value: "sizeable",
          text: "Sizeable"
        },
        {
          value: "shoes",
          text: "Shoes"
        },
        {
          value: "accessories",
          text: "Accessories"
        }
      ], // Static Array of size types
      formState: {
        attempted: false,
        invalidShake: false,
        loading: false
      } // Object Determining the Form's state
    };
  },
  watch: {
    // Computes the Filtered Array out of categories fetched from backend.
    categoriesSearch: function() {
      this.filteredCategories = this.categories.filter(str => {
        return this.categoriesSearch == ""
          ? true
          : str.text
              .toLowerCase()
              .includes(this.categoriesSearch.toLowerCase());
      });
      if (this.filteredCategories.length < 1)
        this.filteredCategories = [{ value: null, text: "No such result" }];
    },
    // When selectedCategoryId is changed, the Category's Data is fetched from the backend, If null is selected, the form is reset.
    selectedCategoryId: function() {
      if (this.selectedCategoryId) {
        this.fetchAllCategoryData(this.selectedCategoryId);
      } else {
        this.partiallyResetForm();
      }
    },
    "$route.params.categoryType": function() {
      this.partiallyResetForm();
      this.fetchAllMetas();
      this.fetchAllCategories();
      this.checkForm();
    }
  },
  mounted() {
    // All Meta data and cagtegories is fetched from the backend
    this.fetchAllMetas();
    this.fetchAllCategories();
    this.checkForm();
  },
  methods: {
    getPlural(word) {
      word = String(word);
      return word[word.length - 1] == "y"
        ? word.slice(0, word.length - 1) + "ies"
        : word + "s";
    },
    compress(imageElem, bodyFormDataObj, keyName, checksObj, isMeasurementTable) {
      let catType = this.$route.params.categoryType.toLowerCase();
      const width =  isMeasurementTable ? 665 
                    : catType == "fabric" || catType == "betana" ? 270 
                    : catType == "general"? 700 
                    : catType == "accessory" ? 270
                    : catType == "color" ? 75
                    : catType == "yaka" || catType == "zarzour" || catType == "akmam" ? 75 
                    : 96;
      const height =  isMeasurementTable ? 501 
                      : catType == "fabric" || catType == "betana" ? 112 
                      : catType == "general"? 700 
                      : catType == "accessory" ? 112
                      : catType == "color" ? 45
                      : catType == "yaka" || catType == "zarzour" || catType == "akmam" ? 75
                      : 40;

      const fileName = imageElem.files[0].name;
      const reader = new FileReader();
      console.log(imageElem.files[0]);
      reader.readAsDataURL(imageElem.files[0]);
      return (reader.onload = event => {
        const img = new Image();
        img.src = event.target.result;
        (img.onload = () => {
          const elem = document.createElement("canvas");
          elem.width = width;
          elem.height = height;
          const ctx = elem.getContext("2d");
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, width, height);
          ctx.canvas.toBlob(
            blob => {
              const file = new File([blob], fileName, {
                type: "image/jpeg",
                lastModified: Date.now()
              });
              bodyFormDataObj.set(keyName, file);
              checksObj[0] = true;
            },
            "image/jpeg",
            1
          );
        }),
          (reader.onerror = error => console.log(error));
      });
    },
    // Whenever an input of type file changes, the selected file is uploaded to the backend
    uploadFile(metaObj, index, newMetaFileUpload = false, isMeasurementTable) {
      let id = newMetaFileUpload ? "newMetaFile" + index : "file" + index;
      if(!(document.getElementById(id) && document.getElementById(id).files[0]))
        return;
      metaObj.uploaded = false;
      metaObj.newFileUpload = new FormData();
      let checks = [];
      checks.push([false]);
      // let file = document.getElementById(id).files[0];
      // metaObj.newFileUpload.set("images", file);
      this.formState.loading = true;
      this.compress(
        document.getElementById(id),
        metaObj.newFileUpload,
        "images",
        checks[0],
        isMeasurementTable
      );
      let xbc = () => {
        let proceed = checks[0][0];
        console.log("proceed", proceed)
        if (proceed) {
          return axios
            .post(`${herokuUrl}/adminUpload`, metaObj.newFileUpload, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: getCookie("user")
              }
            })
            .then(res => {
              if (res.data.status) {
                metaObj.uploaded = true;
                metaObj.value = res.data.sources[0];
                this.formState.loading = false;
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " +
                    res.data.message
                );
                this.formState.loading = false;
              }
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " +
                    err.response.data.message
                );
                this.formState.loading = false;
              }
            });
        }
        console.log("Not yet");
        setTimeout(xbc, 200);
      };
      xbc();
    },
    // Partially resets the form
    partiallyResetForm: function() {
      this.selectedCategoryData = null;
      this.selectedNewMetaId = null;
      this.newMetas = [];
      this.errors = [];
      this.formState = {
        attempted: false,
        invalidShake: false,
        loading: false
      };
    },
    // Returns ALL data related to a certain meta.
    // id is the same id in the backend
    // arr is by default the fetched metas, you can pass in another array
    // If searchingInFetchedData is forced to true, the comparison is based on the key category_meta_id NOT id
    findMeta: function(id, arr = this.metas, searchingInFetchedData = false) {
      if (!searchingInFetchedData) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == id) {
            return { ...arr[i] };
          }
        }
      } else {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].category_meta_id == id) {
            return { ...arr[i] };
          }
        }
      }
      return undefined;
    },
    checkForm: function() {
      this.errors = [];
      if (this.selectedCategoryData) {
        if (!this.selectedCategoryData.mainData.title_en) {
          this.errors.push("Title (EN) is required.");
        }
        if (!this.selectedCategoryData.mainData.title) {
          this.errors.push("Title is required.");
        }
        if (!this.selectedCategoryData.mainData.name_en) {
          this.errors.push("Name (EN) is required.");
        }
        if (!this.selectedCategoryData.mainData.name) {
          this.errors.push("Name is required.");
        }
      }
    },
    fetchAllCategories() {
      this.formState.loading = true;
      return Promise.all([
        axios.get(
          `${herokuUrl}/dashboard/getAllCategories/${this.$route.params.categoryType.toLowerCase()}`,
          {
            headers: {
              Authorization: getCookie("user")
            }
          }
        ),
        axios.get(
          `${herokuUrl}/dashboard/getAllParentCategories/${
            this.$route.params.categoryType.toLowerCase() == "color"
              ? "fabric"
              : this.$route.params.categoryType.toLowerCase()
          }`,
          {
            headers: {
              Authorization: getCookie("user")
            }
          }
        ),
        axios.get(`${herokuUrl}/dashboard/getAllCategories/fabric`, {
          headers: {
            Authorization: getCookie("user")
          }
        })
      ])
        .then(results => {
          // eslint-disable-next-line
          console.log(results);
          let res = results[0];
          this.categories = [
            {
              value: null,
              text: "Please select a category to edit"
            }
          ];
          res.data[this.$route.params.categoryType.toLowerCase()].forEach(
            element => {
              this.categories.push({
                text: element.name_en,
                value: element.id
              });
            }
          );
          this.parentCategories =
            this.$route.params.categoryType.toLowerCase() == "general"
              ? [{ text: "None", value: null }]
              : [];
          if (this.$route.params.categoryType.toLowerCase() == "color") {
            results[1].data.parentCategories = results[2].data.fabric.filter(
              item1 => {
                return results[1].data.parentCategories.find(item2 => {
                  return item1.id == item2.id;
                }) == undefined
                  ? true
                  : false;
              }
            );
          }
          results[1].data.parentCategories.forEach(parentCat => {
            this.parentCategories.push({
              text: parentCat.name_en,
              value: parentCat.id
            });
          });
          this.filteredCategories = [...this.categories];
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Categories fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    fetchAllMetas() {
      this.formState.loading = true;
      return axios
        .post(`${herokuUrl}/dashboard/getAllMetas`, null, {
          headers: {
            Authorization: getCookie("user")
          }
        })
        .then(res => {
          res.data.metas.forEach(element => {
            this.metas.push({
              id: element.id,
              type: element.type,
              valueType: element.value_type
              // model: null
            });
            this.selectionMetas.push({
              value: element.id,
              text: element.type,
              valueType: element.value_type
            });
          });
          res.data.metasOptions.forEach((opts, index) => {
            let optionsArr = [
              {
                value: null,
                text: "Select an option"
              }
            ];
            opts.forEach(element => {
              optionsArr.push({
                value: element.option,
                text: element.option
              });
            });
            this.metas[index].options = optionsArr;
          });
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Categories fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    fetchAllCategoryData(id) {
      this.formState.loading = true;
      return axios
        .post(
          `${herokuUrl}/dashboard/getAllCategoryData`,
          {
            id
          },
          {
            headers: {
              Authorization: getCookie("user")
            }
          }
        )
        .then(res => {
          this.partiallyResetForm();
          this.selectedCategoryData = { ...res.data.data };
          this.selectedCategoryId = this.selectedCategoryData.mainData.id;
          this.formState.loading = false;
          this.checkForm();
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Categories fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    deleteCategory() {
      if (confirm("Please confirm you want to DELETE the selected category")) {
        this.formState.loading = true;
        return axios
          .post(
            `${herokuUrl}/dashboard/deleteCategory`,
            {
              id: this.selectedCategoryData.mainData.id
            },
            {
              headers: {
                Authorization: getCookie("user")
              }
            }
          )
          .then(() => {
            alert("Category was deleted successfully");
            this.partiallyResetForm();
            this.selectedCategoryId = null;
            this.formState.loading = false;
            this.fetchAllCategories();
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem deleting the selected category  " +
                  err.response.data.message
              );
            }
          });
      }
    },
    commitChanges() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the selected category with the new data"
          )
        ) {
          this.formState.loading = true;
          let metasObj = [];
          this.newMetas.forEach(elem => {
            if (elem.valueType == "file" && elem.value) {
              metasObj.push({
                value: elem.value,
                category_id: this.selectedCategoryData.mainData.id,
                category_meta_id: elem.id,
                value_type: elem.valueType
              });
            } else if (elem.data && elem.data != "") {
              metasObj.push({
                value: elem.data,
                category_id: this.selectedCategoryData.mainData.id,
                category_meta_id: elem.id,
                value_type: elem.valueType
              });
            }
          });
          // let fileUploads = [];
          let newCategoryObject = {
            data: {
              ...this.selectedCategoryData,
              newMetas: metasObj
            }
          };
          return axios
            .post(`${herokuUrl}/dashboard/editCategory`, newCategoryObject, {
              headers: {
                Authorization: getCookie("user")
              }
            })
            .then(() => {
              alert("Category was Edited successfully");
              let tempID = this.selectedCategoryId;
              this.partiallyResetForm();
              this.formState.loading = false;
              this.fetchAllCategories();
              this.fetchAllCategoryData(tempID);
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected category  " +
                    err.error
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    addNewMeta() {
      if (
        this.selectedCategoryId &&
        this.selectedNewMetaId &&
        !this.findMeta(
          this.selectedNewMetaId,
          this.selectedCategoryData.categoryMetaRelations,
          true
        ) &&
        !this.newMetas.find(elem => {
          return elem.id == this.selectedNewMetaId;
        })
      ) {
        this.newMetas.push({
          id: this.selectedNewMetaId,
          category_meta_id: this.selectedNewMetaId,
          ...this.findMeta(this.selectedNewMetaId, undefined, false)
        });
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    }
  },
  components: {
    appNavigation: Navigation
  }
};
</script>
